import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface NomaMarkProps {
    className?: string
}

const LOGO = 'https://new-ss-site.cdn.modulify.website/images/strength-scaling-logo-v2.png'

/* The Strength Scaling mark. The logo file is used as a mask so the shape
   takes the surrounding text colour: white on the ink, ink on the paper. */
export const NomaMark: FC<NomaMarkProps> = ({ className }): ReactNode => {
    return (
        <span
            className={cn('inline-block size-4 shrink-0 bg-current', className)}
            style={{
                WebkitMaskImage: `url(${LOGO})`,
                maskImage: `url(${LOGO})`,
                WebkitMaskSize: 'contain',
                maskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskPosition: 'center'
            }}
            aria-hidden='true'
        />
    )
}
